import styled from "styled-components";
import { Layout } from "antd";

const Styled = styled(Layout.Header)`
  ${(_) => `
  top: 0;
  padding: 0;
  z-index: 1;
  height: 6.4rem;
  display: flex;
  position: sticky;
  box-shadow: none !important;
  align-items: center;
  justify-content: space-between;
  background-color: ${_.theme.token.colorPrimary};
  ${_.theme.shadow.box19}
  .logo { 
    height: 2.593rem;
    cursor: pointer;
  }
  .feedback-btn {
    height: 2.6rem;
    &-title {
      font-size: 1.2rem;
      font-weight: 500 !important;
      line-height: 1.25rem !important;
    }
  }
`}
`;

export default Styled;
